// extracted by mini-css-extract-plugin
export default {"container":"PrioritySports_container__DaTL6","box30":"PrioritySports_box30__HN5Wz","box70":"PrioritySports_box70__kcPrp","hotizontal":"PrioritySports_hotizontal__AHXaj"};